import { LogoProps } from '@atlaskit/logo';
import { colors } from '@atlaskit/theme';

import { onDesktop, onMobile } from '../mobile/responsive';

export const DESKTOP_CARD_SIZE = 126;
export const MOBILE_CARD_SIZE = 88;

export const DEFAULT_ICON_PROPS: LogoProps = {
  iconColor: colors.B200,
  iconGradientStart: colors.B400,
  iconGradientStop: colors.B200,
  size: 'xlarge',
  textColor: colors.N700,
};

export const cardContainerFrameStyle = `
  cursor: pointer;
  display: block;
  color: ${colors.N400};
  text-align: center;
  padding: 0;

  // Bigger card size for desktop
  ${onDesktop(`
    width: ${DESKTOP_CARD_SIZE}px;
  `)}

  // Smaller card size for mobile
  ${onMobile(`
    width: ${MOBILE_CARD_SIZE}px;
  `)};
`;

export const cardContainerStyle = `
  ${cardContainerFrameStyle}
  color: ${colors.N400};

  &:hover {
    color: ${colors.B300};
    text-decoration: none;
  }
`;

export const iconContainerStyle = `
  box-sizing: border-box;
  margin: 0 auto 8px auto;
  padding: 12px 0;

  // Bigger icon for desktop
  ${onDesktop(`
    height: 72px;
    width: 72px;
    border-radius: 16px;
  `)}

  // Smaller icon for mobile
  ${onMobile(`
    height: 40px;
    width: 40px;
    padding: 8px;
    border-radius: 8px;

    span {
      width: 24px;
      height: 24px;
    }
  `)}
`;
